import { ChangeDetectionStrategy, Component, inject, LOCALE_ID, model } from '@angular/core';
import { DsBoxModule, DsImprintModule, DsModalModule } from '@bmw-ds/components';

import { I18nService, useI18n } from '../../i18n/services/i18n.service';

/**
 * This component is needed because of bug DESY-4212,
 * where the imprint language does not otherwise support dynamic language choice.
 *
 * The workaround is a for loop with a tracker that mirrors the DS-Imprint’s language logic,
 * so that this component is destroyed and recreated.
 * This component can then provide the latest locale ID.
 */
@Component({
  selector: 'cdf-imprint-modal',
  imports: [DsImprintModule, DsBoxModule, DsModalModule],
  template: `
    <ds-modal #imprint size="sm" [ds-modal-trigger-for]="imprint" [(isModalOpen)]="imprintOpen" [isDismissable]="true">
      <ds-box-header>{{ i18n('imprintTitle') }}</ds-box-header>
      <ds-box-content>
        <ds-imprint />
      </ds-box-content>
    </ds-modal>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: '../../global-styles/container.scss',
  providers: [{ provide: LOCALE_ID, useFactory: () => inject(I18nService).activeLanguage() }],
})
export class ImprintModalWrapper {
  protected readonly i18nService = inject(I18nService);
  protected readonly i18n = useI18n();

  readonly imprintOpen = model.required<boolean>();
}
